module.exports = __webpack_public_path__ + "static/media/contact.2ec66e0c.png";